import { SelectHTMLAttributes, ReactNode, useId } from 'react'

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string
  options?: string[]
  error?: string
  placeholder?: string
  children?: ReactNode
}

export function Select({ label, options, error, placeholder, className = '', id, children, ...props }: SelectProps) {
  const generatedId = useId()
  const selectId = id || generatedId

  // If no label, render just the select element
  if (!label) {
    return (
      <select
        id={selectId}
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-tessan-green focus:border-transparent transition-colors ${
          error ? 'border-error' : 'border-gray-300'
        } ${className}`}
        {...props}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options ? options.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        )) : children}
      </select>
    )
  }

  return (
    <div className="space-y-1">
      <label htmlFor={selectId} className="block text-sm font-medium text-text-primary">
        {label}
        {props.required && <span className="text-error ml-1">*</span>}
      </label>
      <select
        id={selectId}
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-tessan-green focus:border-transparent transition-colors ${
          error ? 'border-error' : 'border-gray-300'
        } ${className}`}
        {...props}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options ? options.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        )) : children}
      </select>
      {error && (
        <p className="text-xs text-error">{error}</p>
      )}
    </div>
  )
}
